import styles from "./ProductReviewStats.module.scss";
import {Svg} from "@/shared/ui/Svg";

type Props = {
    ratingAVG: number | null;
    totalCountOfReviews: number;
    ratingStats: Record<number, number>;
}

export const ProductReviewStats = ({ratingAVG, totalCountOfReviews, ratingStats}: Props) => {

    return (
        <div className={styles.stats}>
            <p className={styles.ratingAVG}>{ratingAVG}</p>
            <div className={styles.info}>
                <div className={styles.stars}>
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                </div>
                <p className={styles.text}>оценка покупателей</p>
            </div>
        </div>
    );
}
